<template>
  <!--业主管理 ownerManager -->
  <div class="myownerManager">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>业主编号：</span>
              <el-input v-model="rfid" placeholder="请输入业主编号" style="width:140px;" show-word-limit></el-input>
            </div>
            <div class="input-small mr-20">
              <span>业主姓名：</span>
              <el-input v-model="name" placeholder="请输入业主姓名" style="width:140px;" show-word-limit></el-input>
            </div>
            <div class="input-small mr-20">
              <span>业主电话：</span>
              <el-input v-model="mobile" placeholder="请输入业主电话" style="width:140px;" show-word-limit></el-input>
            </div>
            <div class="input-small myinput-mill ">
              <span>关联设备：</span>
              <el-select v-model="isBindDevice" clearable placeholder="请选择">
                <el-option v-for="item in relateStatusList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <el-button type="primary" plain @click="pageIndex=1;search()" class="search-btn">查询</el-button>
            <el-button type="primary" @click="addNewOwner">新增</el-button>
            <el-button type="primary" @click="exportReport" :loading="loading2">导出</el-button>
          </div>
        </el-scrollbar>
      </div>
      <div class="mytable" :style="{'height':heights+'px'}">
        <!--custom-scrollbar-->
        <!--业主列表-->
        <el-table :data="dataList" border :height="heights - 20" style="width: 100%;height:100%;">
          <template slot="empty">
            <span class="noData">
              <img src="../../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="selection" width="44" align="center">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="rfid" label="业主编号" min-width="140">
          </el-table-column>
          <el-table-column prop="username" label="姓名" width="140">
          </el-table-column>
          <el-table-column prop="mobile" width="120" label="手机号">
          </el-table-column>
          <el-table-column prop="address" label="地址" min-width="150">
          </el-table-column>
          <el-table-column prop="gender" label="性别" width="50">
          </el-table-column>
          <el-table-column prop="balanceAlarm" label="余额告警值(元)" width="150">
          </el-table-column>
          <el-table-column prop="isBindDevice" label="关联电表" width="90">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>电表名称: {{ scope.row.deviceNames }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.deviceNos?"已关联":"未关联" }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="isBindWaterDevice" label="关联水表" width="90">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>水表名称: {{ scope.row.waterDeviceNames }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.isBindWaterDevice?"已关联":"未关联" }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column> -->

          <el-table-column prop="balance" label="账户余额(元)" width="120">
            <template slot-scope="scope">
              <p>{{ scope.row.balance ? (scope.row.balance/100).toFixed(2) : '0.00'}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="accountTime" label="开户时间" :formatter="formatTime" width="120">
          </el-table-column>
          <el-table-column label="操作" width="280" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="viewDetails(scope.row)" plain>详情</el-button>
              <el-button size="mini" type="primary" @click="editOwnerInfo(scope.row)" plain>编辑</el-button>
              <el-dropdown>
                <el-button type="primary">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><el-button size="mini" type="primary" @click="refundClick(scope.row)"
                      plain>退费</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button size="mini" type="danger"
                      @click="deleteOwnerInfo(scope.row)">删除</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button size="mini" type="danger"
                      @click="amountOfDeduction(scope.row)">补扣</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button size="mini" type="warning" @click="destruction(scope.row)"
                      plain>销户</el-button></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->

      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
    </div>
    <!--退费弹窗-->
    <el-dialog title="退费" v-dialogDrag :visible.sync="refundShow" width="30%" :close-on-click-modal="false">
      <el-form :model="refundForm">
        <el-form-item label="退费设备" :label-width="formLabelWidth">
          <el-select v-model="device" collapse-tags placeholder="请选择" size='small'>
            <el-option v-for="(item,index) in userDeviceInfo" :key="index" :label="item.deviceName" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户编号" :label-width="formLabelWidth">
          <el-input v-model="refundForm.userNumber" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="refundForm.userName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input v-model="refundForm.address" autocomplete="off" disabled></el-input>
        </el-form-item>

        <el-form-item v-if="device.meterRunType==1 && device.accountType==1" label="剩余电量" :label-width="formLabelWidth">
          <el-input disabled v-model="device.electricity" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item v-if="device.meterRunType==1 && device.accountType==1" label="电量转换金额"
          :label-width="formLabelWidth">
          <el-input disabled v-if="device.electricity ==0" autocomplete="off" placeholder="0"></el-input>
          <el-input disabled v-else v-model="device.electricity/device.conversionRate" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="退费原因" :label-width="formLabelWidth" required>
          <el-input v-model="refundForm.reason" type="text" placeholder="请输入退费原因"></el-input>
        </el-form-item>
        <el-form-item label="退费金额(元)" :label-width="formLabelWidth" required>
          <el-input v-if="device.meterRunType==1 && device.accountType==1" v-model="refundForm.refundAmount"
            type="number" class="numberInput" autocomplete="off"
            :placeholder="refundPlace=device.electricity/device.conversionRate" @input="refundAmountFn"></el-input>
          <el-input v-else v-model="refundForm.refundAmount" type="number" class="numberInput" autocomplete="off"
            :placeholder="refundPlace" @input="refundAmountFn"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" required>
          <el-input v-model="confirmPassword" type="password" autocomplete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refundShow = false && setDeviceNull">取 消</el-button>
        <el-button type="primary" @click="confirmRefund">确 定</el-button>
      </div>
    </el-dialog>
    <!--补扣弹窗-->
    <el-dialog title="补扣" v-dialogDrag :visible.sync="amountOfDeductionShow">
      <el-form :model="deduction">
        <el-form-item label="补扣类型" :label-width="formLabelWidth">
          <el-select v-model="deduction.type" placeholder="补扣类型">
            <el-option label="补" value="补"></el-option>
            <el-option label="扣" value="扣"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额(元)" :label-width="formLabelWidth" required>
          <el-input v-model="deduction.balance" type="number" class="numberInput" autocomplete="off"
            placeholder="请输入补扣金额"></el-input>
        </el-form-item>
        <el-form-item label="补扣原因" :label-width="formLabelWidth">
          <el-input v-model="deduction.desc" type="text" class="numberInput" autocomplete="off"
            placeholder="请输入补扣原因"></el-input>
        </el-form-item>
        <p style="color: red">*补扣操作会直接更改业主的账户余额请谨慎使用</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="amountOfDeductionShow = false">取 消</el-button>
        <el-button type="primary" @click="amountOfDeductionConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!--销户弹窗-->
    <el-dialog v-dialogDrag title="销户操作" custom-class="destruction" :visible.sync="destruction_flag" width="830px"
      center>
      <div class="box">
        <div class="p">
          <div class="li">
            <div class="el-icon-tickets icon"></div>
            <div class="txt">地址:{{from.user&&from.user['地址']}}</div>
          </div>
          <div class="li">
            <div class="el-icon-user-solid icon" style="background: #87CF64;"></div>
            <div class="txt">用户名:{{from.user&&from.user['用户名']}}</div>
          </div>
          <div class="li">
            <div class="el-icon-money icon" style="background: #E6A23C;"></div>
            <div class="txt">余额:<span style="color: #E6A23C;">{{((from.user&&from.user['余额'])/100).toFixed(2)}}</span> 元
            </div>
          </div>
        </div>
        <div class="jiesuan">
          <div class="t">
            <div class="li"><i></i>手机号:<div class="tx">{{from.user&&from.user['手机号']}}</div>
            </div>
            <!-- <div class="li">状态: <div class="tx" style="color: #06c283; font-weight: bold;">合闸</div>
            </div> -->
            <!-- <div class="li">用户编号:<div class="tx">{{from.user&&from.user['用户编号']}}</div>
            </div> -->
          </div>

          <div class="b" v-for="(e, i) in from.table" :key="i">
            <div class="li">
              <div class="name">最后一次抄表时间</div>
              <div class="num">{{e['最后一次抄表时间']}}</div>
            </div>
            <div class="li">
              <div class="name">最后抄表值</div>
              <div class="num">{{e['最后抄表值']}}</div>
            </div>
            <div class="li">
              <div class="name">设备号</div>
              <div class="num">{{e['设备号']}}</div>
            </div>
            <!-- <div class="li"> <el-button type="primary" @click="juesuan(e['设备号'])">核算</el-button></div> -->
            <!-- :style="{opacity:i==0?1:0}" -->
          </div>
        </div>
        <div class="hexiao">
          <div class="t" style="color:#ff9b00"> 销户前请先进行手动结算操作，一旦销户，将不退费，请谨慎操作!</div>
          <div class="b">
            <div class="txt">结算后账户余额: <span style="color: red;">{{((from.user&&from.user['余额'])/100).toFixed(2)}}</span>
              元</div>
            <div class="btn">
              <!-- <el-button @click="destruction_flag = false">核销</el-button> -->
              <el-button @click="refundClick(from.row)">退费</el-button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="destruction_flag = false">取 消</el-button>
        <el-button type="primary" @click="xiaohu(from.row)">销 户</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import infoListMultipleSelection from './infoListMultipleSelection.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import ownerManagerStore from './ownerManagerStore.js'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  import request from "@/api/http.js";
  export default {
    components: {
      infoListMultipleSelection,
      singleSelection,
      elPagination
    },
    props: {},
    data () {
      return {
        loading2: false,
        money: 0,
        heights: document.getElementById('app').clientHeight-240,
        from: {//销户数据
          user: '',
          table: ''
        },
        destruction_flag: false,//销户弹窗
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        userDeviceInfo: [],
        dataList: [{
          flag: 0,
          deviceNames: "088",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: "oK5ra4p0dMdu-Hkap97xDVO6y5fI",
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "a64cd6d4600e451aa624f320cc6e8f52",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 178708,
          entityName: "PcmUser",
          cardState: -1,
          id: "bca76e2e54fd4c47874ca8b83223f3cf",
          edittime: 1714983262e3,
          usercode: "B103",
          deviceNos: [166],
          address: "一楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "14745533161",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "bca76e2e54fd4c47874ca8b83223f3cf",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714983262e3,
          isSSO: 0,
          rfid: "B103",
          accountTime: 1698549453e3,
          isAutomaticBrake: 0,
          cardNumber: null,
          status: 1,
          username: "麦当劳"
        },{
          flag: 0,
          deviceNames: "209",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: null,
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "B754301C98554A4F94014883D66FEF7F",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 0,
          entityName: "PcmUser",
          cardState: 0,
          id: "0c0792fc1bfd4480ad60ce5b317a512c",
          edittime: 171456365e4,
          usercode: "HT209",
          deviceNos: [103],
          address: "",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "13691996629",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "0c0792fc1bfd4480ad60ce5b317a512c",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 171456365e4,
          isSSO: 0,
          rfid: "旋转木马209",
          accountTime: 1693880878e3,
          isAutomaticBrake: 1,
          cardNumber: null,
          status: 1,
          username: "旋转木马"
        },{
          flag: 0,
          deviceNames: "215",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: "oK5ra4nnmEhsPbuWOZyy3CGBbDsA",
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "B754301C98554A4F94014883D66FEF7F",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "e10adc3949ba59abbe56e057f20f883e",
          balance: 156896,
          entityName: "PcmUser",
          cardState: -1,
          id: "343b3fe7f8e3406da01765ee83d5a876",
          edittime: 1714473672e3,
          usercode: "HT215",
          deviceNos: [109],
          address: "99号",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "13602480249",
          balanceAlarm: 300,
          cardType: "ICBC",
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "343b3fe7f8e3406da01765ee83d5a876",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714473672e3,
          isSSO: 0,
          rfid: "客乡情215",
          accountTime: 1714473524e3,
          isAutomaticBrake: 0,
          cardNumber: "",
          status: 1,
          username: "客乡情"
        },{
          flag: 0,
          deviceNames: "107,152,141",
          waterDeviceNames: "",
          gender: "女",
          isExtraCharge: null,
          openId: "oK5ra4rqATFAcH4EHvYLMd_cK5QA",
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "46b852f50c2c44739579c9c9fd9a656f",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 824434,
          entityName: "PcmUser",
          cardState: 0,
          id: "48579259953048b2a23ffd513f6b156c",
          edittime: 1714467546e3,
          usercode: "YT101102",
          deviceNos: [165,154,120],
          address: "一楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "15989790269",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "48579259953048b2a23ffd513f6b156c",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714467546e3,
          isSSO: 0,
          rfid: "101、102",
          accountTime: 1693729397e3,
          isAutomaticBrake: 1,
          cardNumber: null,
          status: 1,
          username: "101"
        },{
          flag: 0,
          deviceNames: "116,117",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: "oK5ra4pv_OwOh_BiMxAyVLPts64M",
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "46b852f50c2c44739579c9c9fd9a656f",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: -12510,
          entityName: "PcmUser",
          cardState: 0,
          id: "0b3a7410b9d04608bd8c2c49b1b36512",
          edittime: 1714467543e3,
          usercode: "YT109110",
          deviceNos: [129,130],
          address: "一楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "15602539637",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "0b3a7410b9d04608bd8c2c49b1b36512",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714467543e3,
          isSSO: 0,
          rfid: "109、110",
          accountTime: 1693732414e3,
          isAutomaticBrake: 1,
          cardNumber: null,
          status: 1,
          username: "109"
        },{
          flag: 0,
          deviceNames: "120",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: null,
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "46b852f50c2c44739579c9c9fd9a656f",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 0,
          entityName: "PcmUser",
          cardState: 0,
          id: "588be4c8067748c2a40d785086dfb573",
          edittime: 1714467539e3,
          usercode: "YTchongdianzhuang",
          deviceNos: [133],
          address: "一楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "13539892128",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "588be4c8067748c2a40d785086dfb573",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714467539e3,
          isSSO: 0,
          rfid: "充电桩",
          accountTime: 1693734024e3,
          isAutomaticBrake: 1,
          cardNumber: null,
          status: 1,
          username: "充电桩"
        },{
          flag: 0,
          deviceNames: "110",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: null,
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "46b852f50c2c44739579c9c9fd9a656f",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 1459669,
          entityName: "PcmUser",
          cardState: -1,
          id: "533195a89fbd4dc1a8b5b1835d5dcfab",
          edittime: 1714467535e3,
          usercode: "YT131",
          deviceNos: [123],
          address: "一楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "18665593726",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "533195a89fbd4dc1a8b5b1835d5dcfab",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714467535e3,
          isSSO: 0,
          rfid: "131",
          accountTime: 1693730234e3,
          isAutomaticBrake: 0,
          cardNumber: null,
          status: 1,
          username: "131"
        },{
          flag: 0,
          deviceNames: "122,147",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: "oK5ra4i-i-5TW3rzHS6IKmfLYCS0",
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "46b852f50c2c44739579c9c9fd9a656f",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 55322,
          entityName: "PcmUser",
          cardState: 0,
          id: "e3d3189a835c47ccac7469d65c52ce11",
          edittime: 1714467531e3,
          usercode: "YT217220",
          deviceNos: [135,160],
          address: "二楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "18928032831",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "e3d3189a835c47ccac7469d65c52ce11",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714467531e3,
          isSSO: 0,
          rfid: "217、220",
          accountTime: 1693734114e3,
          isAutomaticBrake: 1,
          cardNumber: null,
          status: 1,
          username: "217"
        },{
          flag: 0,
          deviceNames: "134",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: "oK5ra4oEJsXE4wZF0H9Owu8_9JI8",
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "46b852f50c2c44739579c9c9fd9a656f",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 183712,
          entityName: "PcmUser",
          cardState: -1,
          id: "bfa0ad2610f84784bf08638e98c3595e",
          edittime: 1714467528e3,
          usercode: "YT215",
          deviceNos: [147],
          address: "二楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "18926914131",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "bfa0ad2610f84784bf08638e98c3595e",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714467528e3,
          isSSO: 0,
          rfid: "215",
          accountTime: 1693740327e3,
          isAutomaticBrake: 0,
          cardNumber: null,
          status: 1,
          username: "215"
        },{
          flag: 0,
          deviceNames: "145N",
          waterDeviceNames: "",
          gender: "男",
          isExtraCharge: null,
          openId: "oK5ra4jZEAJ2Z7762P5QZmRsbmjY",
          amountOfArrears: null,
          tokenTime: "PERPETUAL",
          memo: null,
          reportDir: "",
          entityid: "46b852f50c2c44739579c9c9fd9a656f",
          rateId: 325797788559361,
          isLock: null,
          realAmount: 0,
          signedTime: null,
          password: "202cb962ac59075b964b07152d234b70",
          balance: 751683,
          entityName: "PcmUser",
          cardState: 0,
          id: "82b0cd05eec544648e3a90b154521b4c",
          edittime: 1714467433e3,
          usercode: "YT123",
          deviceNos: [174],
          address: "一楼",
          rateName: "海天24年4月(0.8)",
          unitName: "商场",
          emailpsw: null,
          isBindDevice: !0,
          errorNum: null,
          mobile: "19558063466",
          balanceAlarm: 1e3,
          cardType: null,
          photo: null,
          emailaddress: null,
          telephone: null,
          userId: "82b0cd05eec544648e3a90b154521b4c",
          changePassword: null,
          realElectricQuantity: 0,
          createTime: 1714467433e3,
          isSSO: 0,
          rfid: "123",
          accountTime: 1693740746e3,
          isAutomaticBrake: 1,
          cardNumber: null,
          status: 1,
          username: "123"
        }],
        device: '',
        rfid: '',
        name: '',
        mobile: '',
        isBindDevice: undefined,
        isBindWaterDevice: undefined,
        warning: '',
        chargeMode: '',
        searchChange: false,
        //补扣对象
        deduction: {
          id: "",
          balance: 0,
          userName: "",
          type: "补",
          desc: "" //补扣原因
        },
        options: [{
          value: 'false',
          label: '否'
        },{
          value: 'true',
          label: '是'
        }],
        formLabelWidth: '120px',
        refundShow: false,
        amountOfDeductionShow: false,
        refundForm: {
          userNumber: '',
          userName: '',
          address: '',
          refundAmount: '',
          remarks: '',
          userId: '',
        },

        refundPlace: "",
        selectBalance: "", //当前的金额
        confirmPassword: '', //密码
        loading: false, //列表加载
        relateStatusList: [
          {
            'name': '已关联',
            'id': 1
          },
          {
            'name': '未关联',
            'id': 2
          },
        ]
      }
    },

    mounted () {
      this.search()
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      chargeModeList () {
        return ownerManagerStore.state.chargeModeList
      },
      // relateStatusList () {
      //   return ownerManagerStore.state.deviceStatusList
      // },

      balanceAlertChoice () {
        return [{
          'label': '告警',
          'value': 0
        },{
          'label': '不告警',
          'value': 1
        }]
      },

      columns () {
        return ownerManagerStore.state.columns
      },
    },
    watch: {
      dataList (nv,ov) {
        ownerManagerStore.commit('getBindedDeviceNos')
      },
      nowUnit (nv,ov) {
        this.getOwnerList(nv)
      },
      rfid (nv,ov) {
        this.searchChange=true
      },
      name (nv,ov) {
        this.searchChange=true
      },
      mobile (nv,ov) {
        this.searchChange=true
      },
      isBindDevice (nv,ov) {
        this.searchChange=true
      },
      isBindWaterDevice (nv,ov) {
        this.searchChange=true
      },
      pageIndex () {
        this.search()
      }
    },
    methods: {
      refundAmountFn (v) {


      },
      // 销户
      xiaohu (row) {
        this.$confirm(`是否确定销户?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params={
            targetIds: row.id
          }
          request({url: "/accountCancellation/addUserAccountCancellation",method: "get",params}).then(res => {
            if(res.success) {
              this.$message({
                type: 'success',
                message: res.data
              });
              this.search();
              this.destruction_flag=false;
            } else {
              this.$message({
                type: 'info',
                message: '失败!'
              });
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 核算
      juesuan (row) {
        console.log(row);
        var params={
          targetId: this.from.id,
          deviceNos: row,
        }
        request({url: "/accountCancellation/stopDevice",method: "get",params}).then(res => {
          console.log(res,2);
          if(res.success) {
            var d=res.data.olas
            for(const key in d) {
              this.$notify({
                title: '提示',
                message: '表号：'+key+' 当前读数：'+d[key],
              });
            }

            this.$message({
              type: 'success',
              message: '核算成功!'
            });
          }

        })
      },
      // 销户
      destruction (row) {
        var params={
          targetId: row.id
        }
        console.log("销户",row);
        request({url: "/accountCancellation/getCurrentUserData",method: "get",params}).then(res => {
          this.from.user=res.data['用户'];
          this.from.table=res.data['表'];
          this.from.id=row.id;
          this.from.row=row;
          console.log(this.from,1);
        })
        this.destruction_flag=true;
      },
      refundClick (val) {

        this.getUserDeviceList(val);
        this.money=(val.balance/100).toFixed(2);
        //退费
        this.refundForm.userNumber=val.rfid
        this.refundForm.userName=val.username
        this.refundForm.address=val.address
        this.selectBalance=val.balance
        this.refundPlace='最多可退'+this.money+'元'
        this.refundForm.userId=val.userId
        this.confirmPassword=''
        this.refundForm.refundAmount=''
        this.refundForm.remarks=''
        this.refundShow=true
      },

      setDeviceNull () {
        this.device={};
      },

      confirmRefund () {
        if(isempty(this.confirmPassword)) {
          this.$message.error('请输入密码')
          return
        }

        if(isempty(this.device)) {
          this.$message.error("请选择退款设备");
          return
        }

        if(this.refundForm.refundAmount==0) {
          this.$message.error("账户余额为0，无需退费");
          return
        }

        if(this.refundForm.refundAmount<0) {
          this.$message.error("'用户账户存在欠款，请充值");
          return
        }

        if(isempty(this.refundForm.refundAmount)) {
          this.$message.error('退费金额或者输入格式不对！')
          return
        }

        var refType=1; //1==退余额；2==退电量
        if(this.device.accountType==1&&this.device.meterRunType==1) {

          if(this.refundForm.refundAmount>(this.device.electricity/this.device.conversionRate)) {
            this.$message.error('退款金额大于账户余额')
            return
          }

          //退电量  金额线下退还
          //this.refundForm.refundAmount = this.refundForm.refundAmount * this.device.conversionRate;
          refType=2;

        } else {

          if(this.refundForm.refundAmount*100>this.selectBalance) {
            this.$message.error('退款金额大于账户余额')
            return
          }

          this.refundForm.refundAmount=this.refundForm.refundAmount*100;

        }
        //退费
        this.$api.meterReadingApi.refundAmount(this.device.conversionRate,this.device.deviceNo,refType,this.refundForm.userId,this.refundForm.refundAmount,this.refundForm.reason,hex_md5(this.confirmPassword),respon => {
          this.$message.success(respon)
          this.search()
          this.refundShow=false
        },err => {
          this.$message({
            type: 'error',
            message: err
          });
        })

        this.setDeviceNull();
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.search()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.search()
      },
      // 选择计费方式
      selectChargeMode (item) {
        this.chargeMode=item.value
      },
      addNewOwner () {
        this.$emit('add')
      },
      viewDetails (item) {
        this.$emit('view',item)
      },
      // 编辑业主
      editOwnerInfo (item) {
        this.$emit('edit',item)
        ownerManagerStore.commit('setOwnerEditing',item)
      },
      deleteOwnerInfo (item) {
        this.getUserDeviceList(item);
        this.$confirm("确认删除业主编号："+item.rfid+' 姓名：'+item.username+'的业主信息？','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log("删除");
          if(!this.deleteCheck(item)) {
            return
          }

          this.$api.userApi.deleteUserById(item.id,res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.search()
            ownerManagerStore.commit('getAllOwnerRfidList')
            ownerManagerStore.commit('getBindedDeviceNos')
            ownerManagerStore.commit('getDeviceNos',this.nowUnit.id)

          },message => {
            console.log(message);
            this.$message(message)
          })
        }).catch(() => {
          console.log("取消删除");
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //业主设备列表
      getUserDeviceList (val) {
        this.$api.meterReadingApi.getUserDeviceList(val.userId,respon => {
          this.userDeviceInfo=respon;
          if(this.userDeviceInfo.length) {
            this.device=this.userDeviceInfo[0]
          }
        })
      },

      amountOfDeduction (val) {
        //退费
        this.deduction.userName=val.username
        this.deduction.id=val.userId
        this.amountOfDeductionShow=true
      },
      amountOfDeductionConfirm () {
        //补扣
        if(!this.deductionCheck()) {
          return;
        }
        this.$confirm("确认业主："+this.deduction.userName+','+this.deduction.type+this.deduction.balance+"元?",'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //补扣
          this.$api.userApi.amountOfDeduction(this.deduction.id,this.deduction.balance,this.deduction.desc,this.deduction.type,respon => {
            this.$message({
              type: 'success',
              message: '补扣成功!'
            });
            this.search()
            ownerManagerStore.commit('getAllOwnerRfidList')
            ownerManagerStore.commit('getBindedDeviceNos')
            ownerManagerStore.commit('getDeviceNos',this.nowUnit.id)
            this.deduction.balance=""
            this.deduction.desc=""
            this.amountOfDeductionShow=false
          },message => {
            this.$message(message)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消补扣'
          });
        });
      },

      deductionCheck () {
        if(this.deduction.balance<=0) {
          this.$message.error('请输入正确的补扣金额')
          return false;
        }

        if(this.deduction.desc=="") {
          this.$message.error('请输入补扣原因')
          return false;
        }

        return true;

      },

      // 批量删除
      deleteBatches () {
        var keys=Object.keys(this.$refs.infoList.nowSelectIds)
        var ownerIds=[]
        keys.forEach(key => {
          if(this.$refs.infoList.nowSelectIds[key]) {
            ownerIds.push(key)
          }
        })
        if(ownerIds.length<=0) {
          this.$dialogMethod.showMessage('请选择要批量删除的业主！')
          return
        }
        this.$api.userApi.deleteUserById(ownerIds.join(','),respon => {
          this.$dialogMethod.showMessage('批量删除业主成功！')
          this.search()
          ownerManagerStore.commit('getAllOwnerRfidList')
          ownerManagerStore.commit('getBindedDeviceNos')
        },message => {
          this.$dialogMethod.showMessage(message)
        })
      },
      exportReport () {
        // 
        var params={
          unitId: this.nowUnit.id,
          fileName: '业主管理',
          ownerName: this.ownerName,
          detailType: this.noticeType,
          rfid: this.rfid,//业主编号
          name: this.name,//业主姓名
          mobile: this.mobile,//业主电话 
        };

        // baseURL
        var a=localStorage.getItem('baseURL');//获取网址
        var b=a||DWSystemSetting.baseURL;//判断使用备用网址
        var url=b+'/meterReading/exportOwnerListAll'
        for(var key in params) {
          if(url.indexOf('?')===-1) {
            url+='?'
            url+=(key+'='+params[key])
          } else {
            if(params[key]) {
              url+=('&'+key+'='+params[key])
            }

          }
        };
        console.log(this.isBindDevice,'this.isBindDevice');
        if(this.isBindDevice) {
          var a=this.isBindDevice==1? true:false;
          var url=url+'&isBindDevice='+a;

        }
        console.log(JSON.stringify(url));

        window.open(url,"_blank");
        // request({url: "/meterReading/exportOwnerListAll",method: "get",params}).then(res => {
        //   this.loading2=false;

        // })
        // this.$api.meterReadingApi.exportOwnerList(this.rfid,this.name,this.mobile,this.isBindDevice==''? false:this.isBindDevice,this.warning,respon => {
        //   this.loading2=false;
        //   saveAs(DWSystemSetting.downloadUrl+'/'+respon,'业主信息表'+".xls")
        // })
      },
      search () {
        this.getOwnerList(this.nowUnit)
      },
      getOwnerList (unit) {
        if(!unit||!unit.id) {
          return
        }
        this.loading=true
        this.$api.meterReadingApi.getOwnerList(unit.id,this.pageIndex,this.pageSize,this.rfid,this.name,this.mobile,this.isBindDevice,respon => {
          this.total=respon.total
          var list=respon.dataList
          if(this.isBindDevice=="") {
            this.isBindDevice=undefined
          }
          if(this.isBindDevice==undefined) {//无需判断关联设备
            this.dataList=list
          } else {
            if(this.isBindDevice=='1') {
              this.dataList=list.filter(item => item.deviceNos!=null)//已关联设备
            } else {
              this.dataList=list.filter(item => item.deviceNos==null)//未关联设备
            }
          }
          // this.dataList=respon.dataList
          this.loading=false
        })
      },
      // 切换每页显示条数
      pageSizeChange (pageSize) {
        this.pageIndex=1
        this.pageSize=pageSize
        this.search()
      },
      // 切换当前显示页码
      jumpToPage (pageIndex) {
        this.pageIndex=pageIndex
        this.search()
      },
      formatTime (row,column,cellValue) {
        return new Date(row.accountTime).format('yyyy-MM-dd')
      },

      //删除业主、批量删除业主  判断
      deleteCheck (item) {
        if(item.balance!=0&&!isempty(item.balance)) {
          this.$message.error('用户账户未结算，请先结算')
          return false;
        }

        let deviceList=this.userDeviceInfo;

        this.userDeviceInfo.forEach(function(value,index,deviceList) {
          if(value.electricity!=0&&!isempty(value.electricity)) {
            this.$message.error('电表剩余电量未清零')
            return false;
          }
        })
        return true;
      }

    }
  }
</script>

<style scoped lang="scss">
  .myownerManager {
    width: 100%;
    height: 100%;

    .con {
      width: 100%;
      height: 100%;
      padding: 2px 20px 12px 20px;
      background-color: #fff;
      box-sizing: border-box;
      overflow: hidden;
    }

    .myinput-mill {
      /deep/.el-input__inner {
        width: 90px;
      }

      /deep/.el-input {
        width: 90px !important;
      }

    }

    .my-search-i {
      /deep/.el-button {
        padding: 10px 14px !important;
      }
    }
  }

  .box .hexiao .txt {
    font-weight: bold;
  }

  .paging {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  .box .hexiao .t {
    line-height: 25px;
    margin-top: 15px;
  }

  .box .hexiao .b {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }

  .box .jiesuan .b .li {
    margin-top: 15px;
    line-height: 25px;

  }

  .box .jiesuan .b {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }

  .box .jiesuan {
    border-bottom: 1px solid #d7d7d7;
    padding: 20px;
    position: relative;
  }

  .box .jiesuan .t {
    display: flex;
    justify-content: space-between;
  }

  .box .jiesuan .t i {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #1f87ff;
    left: 4px;
    top: 25px;
  }

  .box .jiesuan .t .tx {
    display: inline-block;
    min-width: 95px;
  }

  .box .p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
    padding-bottom: 25px;
    font-weight: bold;
  }

  .box .p .li {
    display: flex;
    align-items: center;
  }

  .box .p .li .icon {
    background: #409EFF;
    border-radius: 50%;
    font-size: 15px;
    color: #fff;
    padding: 4px;
    margin-right: 9px;
  }


  .page_top_form::-webkit-scrollbar {
    width: 5px;
  }


  .ownerList {
    padding: 0 20px 0 20px;
    height: calc(100% - 73px);
  }

  .ownerList::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .ownerList::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .ownerList:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .ownerList::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .ownerList:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .ownerList>div {
    width: calc(100% - 10px);
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .operateBtn:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 1500px) {
    .ownerList {
      height: calc(100% - 96px);
    }
  }
</style>